import { ArgsType, Field } from '@nestjs/graphql'
import { MaxLength } from '@nestjs/class-validator'
import { bsConstants } from '../../module.constants'

const { APPLICATION } = bsConstants.SUBSCRIPTIONS.PLANS.PUBLISHER

/** The checkout's Business Info step [sc-29190]. Both answers are required; the API trims and checks them. */
@ArgsType()
export class SubmitPublisherApplicationArgs {
  @Field()
  @MaxLength(APPLICATION.WEBSITE_MAX_LENGTH)
  website!: string

  @Field()
  @MaxLength(APPLICATION.INFORMATION_MAX_LENGTH)
  information!: string
}
